/**
 * Sometimes it happens for the AutoSizer component to make a mistake
 * of 1px when calculating dynamic element height. This behavior can lead for a
 * wrong vertical scroll bar to appear on window. Being minded about it,
 * we have to remove 1px from the supplied height.
 */
export const consolidateAutoSizerHeight = (height: number): number => {
	return height - 1
}
